<div class="image-modal-header">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <em class="icon-close_medium" aria-hidden="true"></em>
    </button>
</div>
<div class="image-modal-body text-center">
    <img [src]="image.url" [alt]="image.caption" class="img-fluid" />
    <div class="image-caption">
        <a [attr.href]="image.sourceUrl" target="_blank">{{image.fileName}}<em
            *ngIf="image.sourceUrl" class="icon-external"></em></a>
        <div>{{image.caption}}</div>
    </div>
</div>
